export default __webpack_public_path__ + "97160d5dcd51d7ce16ed61179b968140.png";